import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBX_b93nWJPRa8U7lv6GatDvHoBasvz5oA",
  authDomain: "apurdu-news.firebaseapp.com",
  projectId: "apurdu-news",
  storageBucket: "apurdu-news.appspot.com", // Yahan check karein
  messagingSenderId: "820598229536",
  appId: "1:820598229536:web:362a4c47ce3284e4130a45"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);